import type { MouseEvent, ReactNode } from "react";

import type { View } from "@/lib/app-view";

function appHref(view: View, recordId?: string) {
  const params = new URLSearchParams({ view });
  if (recordId) params.set("record", recordId);
  return `/app?${params.toString()}`;
}

export function AppLink({
  view,
  recordId,
  navigate,
  children,
  className = "",
  ariaLabel,
}: {
  view: View;
  recordId?: string;
  navigate: (view: View, recordId?: string) => void;
  children: ReactNode;
  className?: string;
  ariaLabel?: string;
}) {
  function follow(event: MouseEvent<HTMLAnchorElement>) {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    )
      return;
    event.preventDefault();
    navigate(view, recordId);
  }

  return (
    <a
      href={appHref(view, recordId)}
      onClick={follow}
      aria-label={ariaLabel}
      className={`rounded-sm underline-offset-4 hover:text-[var(--action-hover)] hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus)] focus-visible:ring-offset-2 ${className}`}
    >
      {children}
    </a>
  );
}
